// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "comstatic/js/" + chunkId + "." + "24a1be6a" + ".chunk.js";
};